import { Component, Input } from '@angular/core';
import { SewSkeleton } from '@sew/ui-components-angular/standalone';

@Component({
    selector: 'ecs-part-table-skeleton',
    templateUrl: './part-table-skeleton.component.html',
    styleUrls: ['./part-table-skeleton.component.scss'],
    imports: [SewSkeleton],
})
export class PartTableSkeletonComponent {
    @Input() public showGroupHeader = true;
    @Input() public set rowCount(count: number) {
        if (count === null || count < 1) {
            return;
        } else {
            this.rows = [...Array(count).keys()];
        }
    }

    public rows: Array<number> = [];
}
